import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CompaniesApiService } from 'features/companies/api/companies-api.service';
import { userQueryKeys } from 'features/users/use-cases/query-keys';
import { User } from 'types';
// ../api/companies-api.service
const { getTCdetails } = CompaniesApiService();
const getUserQuery = (
  id: string,
  options?: UseQueryOptions<User>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<User>;
  options?: UseQueryOptions<User>;
} => ({
  queryKey: userQueryKeys.detail(id),
  queryFn: ({ signal }) => getTCdetails(id, { config: { signal } }),
  ...options,
});

export const useGetCompanyTcdetails = (
  id: string,
  options?: UseQueryOptions<any>,
) => {
  const { message } = App.useApp();

  return useQuery<any, Error>(
    getUserQuery(id, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};
